'use client';
import { type ComponentType, type ForwardedRef } from 'react';

import { motion, type MotionProps } from 'framer-motion';

/* eslint-disable-next-line no-restricted-imports -- This is necessary in order to avoid the missing
   'displayName' on 'Stack' throwing an error during 'motion.create()'. */
import Stack, { type StackProps } from '@mui/material/Stack';

export const InheritedMotionStackPropNames = [
  'animate',
  'exit',
  'initial',
  'layout',
  'layoutId',
  'layoutDependency',
  'variants',
  'transition',
  'onAnimationComplete',
  'onAnimationStart',
] as const satisfies (keyof MotionProps)[];

export type InheritedMotionStackPropName = (typeof InheritedMotionStackPropNames)[number];

export type InheritedMotionStackProps = Pick<MotionProps, InheritedMotionStackPropName>;

export type AnimatedStackProps = {
  readonly ref?: ForwardedRef<HTMLDivElement>;
} & InheritedMotionStackProps &
  Omit<StackProps, Extract<keyof StackProps, `onAnimation${string}`>>;

// Note: This type definition is only required due to rollup, for reasons that are unclear.
type AnimatedStackComponentType = ComponentType<AnimatedStackProps>;

export const AnimatedStack: AnimatedStackComponentType = motion.create(
  Stack,
) as AnimatedStackComponentType;
